:host {
  @include base-invert;
  @include button-invert;

  --background-color: #{$colorError60};
  --icon-color: #{$baseInvertColor};
  --close-color: #{$baseInvertColor};
  --label-color: #{$baseInvertColor};
}

.stzh-banner {
  position: relative;
  box-shadow: $boxShadowMessage;
  border-radius: #{$buttonBorderRadius};
  background-color: var(--background-color);

  &__container {
    @include container;
    @include spaceCurve('padding-top', 'small');
    @include spaceCurve('padding-bottom', 'small');
    @include spaceCurve('padding-right', 'huge');
    margin-right: 0;

    @include mq($from: small) {
      margin-right: 0px;
    }

    @include mq($from: medium) {
      margin-right: 0px;
    }

    @include mq($from: large) {
      margin-right: 0px;
    }

    @include mq($from: ultra) {
      margin-right: auto;
    }
  }

  &__content {
    @include spaceCurve('gap', 'small');
    display: flex;
  }

  &__icon-wrapper {
    display: flex;
    flex-shrink: 0;
  }

  &__icon {
    color: var(--icon-color);
  }

  &__text-wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    @include mq($from: medium) {
      @include spaceCurve('column-gap', 'small');
      @include spaceCurve('row-gap', 'tiny');
      flex-wrap: wrap;
      flex-direction: row;
      align-items: center;
    }
  }

  &__label {
    @include font('heavy');
    @include fontSize('milli');
    color: var(--label-color);

    @include mq($from: small) {
      @include fontSize('centi');
    }
  }

  &__close[variant="tertiary"] {
    --color: var(--close-color);

    position: absolute;
    top: 0;
    right: 0;

    @include mq($from: small) {
      top: 10px;
      right: 10px;
    }
  }
}
